export default function Badge({ children, tone = "standard" }) {
  const cls =
    tone === "admin"
      ? "badge-admin"
      : tone === "success"
      ? "badge-success"
      : tone === "pending"
      ? "badge-pending"
      : tone === "error"
      ? "badge-error"
      : "badge-standard";
  return <span className={`badge ${cls}`}>{children}</span>;
}
